import { render, staticRenderFns } from "./NumericEditor.vue?vue&type=template&id=0373c4a3&scoped=true&"
import script from "./NumericEditor.vue?vue&type=script&lang=js&"
export * from "./NumericEditor.vue?vue&type=script&lang=js&"
import style0 from "./NumericEditor.vue?vue&type=style&index=0&id=0373c4a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373c4a3",
  null
  
)

export default component.exports